module.exports = __webpack_public_path__ + "img/03-pic-livepen.80e8cff1.png";